// extracted by mini-css-extract-plugin
export default {"claim":"Claim_claim__OHxHS","container":"Claim_container__EVncv","claimInfo":"Claim_claimInfo__06LJC","claimInfoLink":"Claim_claimInfoLink__4kggI"};